/**
 * wxid-微信id
 * initial-姓名首字母
 * headerUrl-头像地址
 * nickname-昵称
 * sex-性别 男1女0
 * remark-备注
 * signature-个性签名
 * telphone-电话号码
 * album-相册
 * area-地区
 * from-来源
 * desc-描述
 */
const contacts = [{ //昵称备注都有的朋友
        "wxid": "wxid_zhaohd",
        "initial": 'z',
        "headerUrl": "/images/header/header01.png",
        "nickname": "阿西",
        "sex": 1,
        "remark": "阿西",
        "signature": "填坑小能手",
        "telphone": 18896586152,
        "album": [{
            imgSrc: ""
        }],
        "area": ["中国", "北京", "海淀"],
        "from": "",
        "tag": "",
        "desc": {
        }
    },
    {
        "wxid": "wxid_wenxian2012",
        "initial": 'w',
        "headerUrl": "/images/header/new/文贤.png",
        "nickname": "小闲闲",
        "sex": 1,
        "remark": "小闲闲",
        "signature": "不要叫我小闲闲",
        "telphone": 18896586152,
        "album": [{
            imgSrc: ""
        }],
        "area": ["中国", "北京", "海淀"],
        "from": "",
        "tag": "",
        "desc": {
        }
    },
    {
        "wxid": "wxid_baiqian",
        "initial": 'b',
        "headerUrl": "/images/header/baiqian.jpg",
        "nickname": "白浅",
        "sex": 0,
        "remark": "",
        "signature": "青丘女帝，天族天妃",
        "telphone": 18896586152,
        "album": [{
            imgSrc: "/images/album/baiqian/baiqian01.jpeg",
            date: 182625262
        }, {
            imgSrc: "/images/album/baiqian/baiqian02.jpeg",
            date: 182625262
        }],
        "area": ["青丘", "狐狸洞"],
        "from": "通过扫一扫",
        "tag": "女帝",
        "desc": {
            "title": "",
            "picUrl": ""
        }
    }, { //昵称备注都有的朋友
        "wxid": "wxid_yehua",
        "initial": 'y',
        "headerUrl": "/images/header/yehua.jpg",
        "nickname": "夜华",
        "sex": 1,
        "remark": "夜华",
        "signature": "浅浅，过来",
        "telphone": 18896586152,
        "album": [{
            imgSrc: "/images/album/guanyu/guanyu02.jpeg",
            date: 182625262
        }, {
            imgSrc: "/images/album/baiqian/baiqian02.jpeg",
            date: 182625262
        }],
        "area": ["九重天", "洗梧宫"],
        "from": "通过扫一扫",
        "tag": "太子",
        "desc": {
            "title": "",
            "picUrl": ""
        }
    },
    {
        "wxid": "wxid_chenz",
        "initial": 'c',
        "headerUrl": "/images/header/new/陈增.png",
        "nickname": "陈增",
        "sex": 1,
        "remark": "陈增",
        "signature": "惟贤惟德，仁服于人",
        "telphone": 18896586152,
        "album": [{
            imgSrc: "/images/album/guanyu/guanyu02.jpeg",
            date: 182625262
        }, {
            imgSrc: "/images/album/baiqian/baiqian01.jpeg",
            date: 182625262
        }],
        "area": ["浙江", "杭州"],
        "from": "通过扫一扫",
        "tag": "",
        "desc": {
            "title": "",
            "picUrl": ""
        }
    },
    {
        "wxid": "wxid_chaoqun",
        "initial": 'c',
        "headerUrl": "/images/header/new/超群.png",
        "nickname": "超群",
        "sex": 1,
        "remark": "超群",
        "signature": "观尔乃插标卖首",
        "telphone": 18896586152,
        "album": [{
            imgSrc: "/images/album/baiqian/baiqian02.jpeg",
            date: 182625262
        }, {
            imgSrc: "/images/album/guanyu/guanyu01.jpeg",
            date: 182625262
        }],
        "area": ["浙江", "温州"],
        "from": "通过扫一扫",
        "tag": "",
        "desc": {
            "title": "",
            "picUrl": ""
        }
    },
    {
        "wxid": "wxid_zhugeliang",
        "initial": 'z',
        "headerUrl": "/images/header/zhugeliang.jpg",
        "nickname": "诸葛村夫",
        "sex": 1,
        "remark": "诸葛村夫",
        "signature": "你可识得此阵？",
        "telphone": 18896586152,
        "album": [{
            imgSrc: "/images/album/baiqian/baiqian01.jpeg",
            date: 182625262
        }, {
            imgSrc: "/images/album/guanyu/guanyu01.jpeg",
            date: 182625262
        }],
        "area": ["蜀国", "荆州"],
        "from": "通过扫一扫",
        "tag": "卧龙",
        "desc": {
            "title": "",
            "picUrl": ""
        }
    },
    {
        "wxid": "wxid_zovj",
        "initial": 'z',
        "headerUrl": "/images/header/new/Zovj.png",
        "nickname": "Zovj",
        "sex": 0,
        "remark": "Zovj💕",
        "signature": "仿佛兮若轻云之蔽月",
        "telphone": 18896586152,
        "album": [{
            imgSrc: "/images/album/baiqian/baiqian02.jpeg",
            date: 182625262
        }],
        "area": ["吴国", "富春"],
        "from": "通过手机号码添加",
        "tag": "",
        "desc": {
            "title": "",
            "picUrl": ""
        }
    },
    {
        "wxid": "wxid_ada",
        "initial": 'a',
        "headerUrl": "/images/header/new/阿达.png",
        "nickname": "阿达",
        "sex": 1,
        "remark": "阿达",
        "signature": "容我三思",
        "telphone": 18896586152,
        "album": [{
            imgSrc: "/images/album/guanyu/guanyu01.jpeg",
            date: 182625262
        }],
        "area": ["吴国", "吴郡"],
        "from": "通过手机号码添加",
        "tag": "主公",
        "desc": {
            "title": "",
            "picUrl": ""
        }
    },
    {
        "wxid": "wxid_yiyou",
        "initial": 'h',
        "headerUrl": "/images/header/new/咿呦.png",
        "nickname": "咿呦",
        "sex": 0,
        "remark": "咿呦",
        "signature": "哼哼~",
        "telphone": 18896586152,
        "album": [{
            imgSrc: "/images/album/guanyu/guanyu02.jpeg",
            date: 182625262
        }],
        "area": ["上海", "嘉定"],
        "from": "通过手机号码添加",
        "tag": "",
        "desc": {
            "title": "",
            "picUrl": ""
        }
    }, {
        "wxid": "wxid_xiaoqt",
        "initial": 'x',
        "headerUrl": "/images/header/new/小晴天.png",
        "nickname": "小晴天",
        "sex": 0,
        "remark": "小晴天",
        "signature": "仿佛兮若轻云之蔽月",
        "telphone": 18896586152,
        "album": [{
            imgSrc: "/images/album/guanyu/guanyu01.jpeg",
            date: 182625262
        }],
        "area": ["上海", "徐家汇"],
        "from": "通过手机号码添加",
        "tag": "",
        "desc": {
            "title": "",
            "picUrl": ""
        }
    },
    {
        "wxid": "wxid_shim",
        "initial": 's',
        "headerUrl": "/images/header/new/诗梦.png",
        "nickname": "诗梦",
        "sex": 0,
        "remark": "诗梦",
        "signature": "每一缕风都是你的呢喃",
        "telphone": 18896586152,
        "album": [{
            imgSrc: "/images/album/guanyu/guanyu01.jpeg",
            date: 182625262
        }],
        "area": ["上海", "徐家汇"],
        "from": "通过手机号码添加",
        "tag": "",
        "desc": {
            "title": "",
            "picUrl": ""
        }
    },
    {
        "wxid": "wxid_panls",
        "initial": 'p',
        "headerUrl": "/images/header/new/潘老师.png",
        "nickname": "潘老师",
        "sex": 0,
        "remark": "潘老师",
        "signature": "金梦芽少儿培训中心工作微",
        "telphone": 18896586152,
        "album": [{
            imgSrc: "/images/album/guanyu/guanyu01.jpeg",
            date: 182625262
        }],
        "area": ["上海", "徐家汇"],
        "from": "通过手机号码添加",
        "tag": "",
        "desc": {
            "title": "",
            "picUrl": ""
        }
    },
    {
        "wxid": "wxid_xuany",
        "initial": 'x',
        "headerUrl": "/images/header/new/玄元.png",
        "nickname": "玄元",
        "sex": 0,
        "remark": "玄元",
        "signature": "没事别找我",
        "telphone": 18896586152,
        "album": [{
            imgSrc: "/images/album/guanyu/guanyu01.jpeg",
            date: 182625262
        }],
        "area": ["浙江", "杭州"],
        "from": "通过手机号码添加",
        "tag": "",
        "desc": {
            "title": "",
            "picUrl": ""
        }
    },
    {
        "wxid": "wxid_caimour",
        "initial": 'c',
        "headerUrl": "/images/header/new/蔡某人.png",
        "nickname": "蔡某人",
        "sex": 0,
        "remark": "蔡某人",
        "signature": "又菜又爱玩",
        "telphone": 18896586152,
        "album": [{
            imgSrc: "/images/album/guanyu/guanyu01.jpeg",
            date: 182625262
        }],
        "area": ["浙江", "杭州"],
        "from": "通过手机号码添加",
        "tag": "",
        "desc": {
            "title": "",
            "picUrl": ""
        }
    }
]

const contact = {
    contacts
}
contact.getUserInfo = function(wxid) {
    if (!wxid) {
        return;
    } else {
        for (var index in contacts) {
            if (contacts[index].wxid === wxid) {
                return contacts[index]
            }
        }
    }
}

export default contact